import React from "react"

const SectionDivider = () => {
  return (
    <div
      className="section-divider"
      data-anime="opacity:[0, 1]; scale:[0, 1]; onview: true; delay: 100;"
    >
      <img src="/assets/img/others/divider-01.svg" alt="divider" />
    </div>
  )
}

export default SectionDivider
